"use strict";


module.exports = [function () {

        this.deregisterListner;

        this.getDeregisterListner = function () {
            return this.deregisterListner;
        };

        this.setDeregisterListner = function (deregisterListner) {
            this.deregisterListner = deregisterListner;
        };

        this.unregisterListner = function () {
            if (angular.isDefined(this.deregisterListner)) {
                this.deregisterListner();
            }
        };

        return this;
    }];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-utils-notify/services/notify/DeregisterListner.js
// module id = 448
// module chunks = 0